import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

export const useMatchBatchIfYouCanQuery = ({
  careers,
  users,
  with_pre_matching = false,
  options = {}
}) => {
  return useQuery({
    queryKey: QUERY_KEYS.matchBatchIfYouCan(careers, users, with_pre_matching),
    queryFn: async () => {
      const response = await query({
        query: 'matchBatchIfYouCan',
        variables: { careers, users, with_pre_matching }
      })

      if (!response || response === 'undefined') {
        console.error(
          'useMatchBatchIfYouCanQuery: Invalid response received:',
          response
        )
        throw new Error('Invalid response from matchBatchIfYouCan query')
      }

      return response
    },
    ...options
  })
}
